<template>
    <div class="create-visit-form__text">
        <label class="show-for-sr" :for="field.id">{{ field.label }}</label>
        <input :id="field.id" :type="type" :name="field.name" :required="field.required" :placeholder="field.label" @focus="() => {type = field.type}">
    </div>
</template>

<script>
export default {
    name: 'InputField',
    props: ['field'],
    data() {
        return {
            type: 'text',
        }
    }
}
</script>